export default "__VITE_ASSET__BiOXOx2N__"